import { styled } from "../../stitches.config";

export const Option = styled("option");
